<div style="display:inline-block"><span *ngFor="let fltr of filters"><app-filter-pill [filter]="fltr" *ngIf="fltr.value !='All'"></app-filter-pill></span></div>